import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "Store/configureStore";

const serviceKindSelector = createSelector(
  (state: RootState) => state.deployment,
  (_: RootState, props: { ids: string[]; name: string }) => props,
  (deployment, { ids: [organizationId, projectId, environmentId], name }) => {
    const current =
      deployment?.data?.[organizationId]?.[projectId]?.[
        decodeURIComponent(environmentId)
      ]?.current;

    if (!current) {
      return;
    }

    if (current.services[name]) {
      return "Service";
    }

    if (current.webapps[name]) {
      return "Application";
    }

    if (current.workers[name]) {
      return "Worker";
    }
  }
);

export default serviceKindSelector;
